import { ListResponse, PaginationRequest, Response } from './client/types'
import { useAPI } from './client/useAPI'
import { Gender } from '../../lib/types'
import { IdentityDocument } from './documents'
import { CompanyListItem } from './companies'

export type EmployeeListItem = {
  id: string
  firstNameRu: string
  middleNameRu: string
  lastNameRu: string
  firstNameEn: string
  lastNameEn: string
  birthdate: string
  gender: Gender
  countryCode: string
  email: string
  phoneNumber: string
}

export type EmployeeListRequest = PaginationRequest & {
  companyId?: string
  search?: string
}

type EmployeeListResponse = ListResponse<EmployeeListItem>

export const useEmployees = () => {
  return useAPI<EmployeeListResponse, EmployeeListRequest>(
    'GET',
    '/employees',
    {
      withToken: true,
    }
  )
}

export type EmployeeData = {
  id: string
  firstNameRu: string
  middleNameRu: string
  lastNameRu: string
  firstNameEn: string
  lastNameEn: string
  gender: Gender
  birthdate: string
  countryCode: string
  email: string
  phoneNumber: string
  companyId: string
  company: CompanyListItem
}

type EmployeeResponse = Response<EmployeeData>

export const useEmployee = (id: string) => {
  return useAPI<EmployeeResponse>('GET', `/employees/${id}`, {
    withToken: true,
  })
}

export type EmployeeFormData = {
  companyId: string
  firstNameRu: string
  middleNameRu?: string
  skipMiddleName: boolean
  lastNameRu: string
  firstNameEn: string
  lastNameEn: string
  gender: string
  birthdate: string
  countryCode: string
  email?: string | null
  phoneNumber?: string | null
}

type EmployeeFormRequest = EmployeeFormData
type EmployeeFormResponse = EmployeeResponse

export const useSaveEmployee = (id: string) => {
  return useAPI<EmployeeFormResponse, EmployeeFormRequest>(
    'PATCH',
    `/employees/${id}`,
    {
      withToken: true,
    }
  )
}

export const useCreateEmployee = () => {
  return useAPI<EmployeeFormResponse, EmployeeFormRequest>(
    'POST',
    '/employees',
    {
      withToken: true,
    }
  )
}

export type EmployeeDocumentsListResponse = ListResponse<IdentityDocument>

export const useEmployeeDocuments = (id: string) => {
  return useAPI<EmployeeDocumentsListResponse>(
    'GET',
    `/employees/${id}/documents`,
    {
      withToken: true,
    }
  )
}
